// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"475":"677c3335","488":"ddb4abbe","503":"4ad6a30e","609":"cde0826e"}[chunkId] + ".chunk.js";
};